import type { ReactNode } from 'react';

// La fascia in testa a una pagina con la piazza di PopTown sullo sfondo (tela «PopTown Pop Style»,
// Progetti): titolo e sottotitolo bianchi su un velo scuro, l'azione a destra.
export function PopHero({
  title,
  subtitle,
  actions,
}: {
  title: string;
  subtitle?: string;
  actions?: ReactNode;
}) {
  return (
    <header className="pop-hero">
      <img className="pop-hero-town" src="/town/poptown-town.webp" alt="" />
      <span className="pop-hero-veil" aria-hidden />
      <div className="pop-hero-text">
        <h1 className="pop-hero-title">{title}</h1>
        {subtitle && <p className="pop-hero-sub">{subtitle}</p>}
      </div>
      {actions && <div className="pop-hero-actions">{actions}</div>}
    </header>
  );
}
